import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { useZipCodeEditModal } from '@src/quince-site-common/src/hooks/zipcode'

import Button, { BUTTON_TYPES } from '../button'

import styles from './zipCodeButton.module.scss'

export interface ZipCodeButtonProps {
  children: ReactNode
  btnClassName?: string
}

function ZipCodeButton({ children, btnClassName }: ZipCodeButtonProps) {
  const { openZipcodeModal } = useZipCodeEditModal()
  return (
    <Button
      onClick={() => {
        openZipcodeModal(true)
      }}
      className={classNames(styles.buttonStyle, btnClassName)}
      type={BUTTON_TYPES.SECONDARY_LINK}
    >
      {children}
    </Button>
  )
}

export default ZipCodeButton
